import { render } from "./AdSection4.vue?vue&type=template&id=23ef6ce4&scoped=true"
import script from "./AdSection4.vue?vue&type=script&lang=js"
export * from "./AdSection4.vue?vue&type=script&lang=js"

import "./AdSection4.vue?vue&type=style&index=0&id=23ef6ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ef6ce4"]])

export default __exports__